import { useEffect } from "react";
import useLogin from "./useLogin";

export function useTheme() {
    const { preferences } = useLogin();

    function setTheme(theme: "light" | "dark") {
        const elm = document.documentElement;
        if (theme === "light" && !elm.classList.contains("light")) {
            elm.classList.add("light");
        } else if (theme === "dark" && elm.classList.contains("light")) {
            elm.classList.remove("light");
        }
    }

    useEffect(() => {
        const osTheme = window.matchMedia("(prefers-color-scheme: light)");
        setTheme(
            preferences.theme === "system" && osTheme.matches ? "light" : preferences.theme === "light" ? "light" : "dark"
        );

        osTheme.onchange = e => {
            if (preferences.theme === "system") {
                setTheme(e.matches ? "light" : "dark");
            }
        };
        return () => {
            osTheme.onchange = null;
        };
    }, [preferences.theme]);

}